<template>
  <div id="level-card-inner" :style="{ borderColor: $util.borderColor(grade) }">
    <div class="level-card-ctx">
      <img :src="require('../assets/imgs/'+ grade +'/top-left-1.png')" alt id="top-left" />
      <img :src="require('../assets/imgs/'+ grade +'/top-right-1.png')" alt id="top-right" />
      <img :src="require('../assets/imgs/'+ grade +'/bottom-left-1.png')" alt id="bottom-left" />
      <img :src="require('../assets/imgs/'+ grade +'/bottom-right-1.png')" alt id="bottom-right" />
      <div id="level-card-title">
        <img class="level-card-avatar" :src="require('../assets/imgs/'+ grade +'/avatar.png')" alt />
        <span>{{name}}</span>
      </div>
      <div id="level-card-beyond">
        <span id="level-card-beyond-text">测试结果赶超同阶段孩子：</span>
        <span id="level-card-beyond-num" :style="{ color: $util.beyondNum(grade) }">{{beyond}}%</span>
      </div>
      <div style="height: 45%;">
        <b-beyond :beyond="beyond" :beyondIndex="beyondIndex" :grade="grade"></b-beyond>
      </div>
      <div class="test-info">
        <span>测评日期：{{testDate}}</span>
        <span>测评范围：{{testInner}}课时</span>
      </div>
    </div>
  </div>
</template>
<script>
import aaa from "@/assets/imgs/6/bottom-right-1.png";
export default {
  name: "BeyondCard",
  props: {
    name: {},
    beyond: {},
    beyondIndex: {},
    testDate: {},
    testInner: {},
    grade: {}
  }
};
</script>
<style lang="scss">
#level-card-inner {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 100px;
  background-color: #fff;
  z-index: 9;
  border: 30px solid;
  border-radius: 20px;
  width: 90%;
  height: 1050px;
}
.level-card-ctx {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0 4%;
}
#top-left,
#top-right,
#bottom-left,
#bottom-right {
  position: absolute;
  width: 250px;
}
#top-left {
  top: -55px;
  left: -71px;
}
#top-right {
  top: -55px;
  right: -58px;
}
#bottom-left {
  bottom: -70px;
  left: -70px;
}
#bottom-right {
  bottom: -70px;
  right: -60px;
}
#level-card-title {
  width: 100%;
  height: 25%;
  display: inline-flex;
  border-bottom: 1px solid #ddd;
  flex-direction: row;
  align-items: center;
}
.level-card-avatar {
  width: 5%;
  margin-right: 2%;
}
.level-card-avatar span {
  font-size: 1rem;
}

#level-card-beyond {
  width: 100%;
  padding: 1%;
}
#level-card-beyond-text {
  font-size: 1rem;
  color: #888;
}
#level-card-beyond-num {
  font-size: 1.2em;
  color: #f9bd2b;
  font-weight: 600;
}

.test-info {
  display: flex;
  justify-content: space-between;
  margin-top: 2%;
}
.test-info span {
  font-size: 0.8rem;
  color: #888;
}
</style>



// WEBPACK FOOTER //
// src/common/BeyondCard.vue